export default "__VITE_ASSET__b8b5de37__"